import clsx from 'clsx';

export const MapCardContainer = ({
  children,
  className = '',
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => (
  <div className={clsx('[&>*:last-child]:mb-0', className)} onClick={onClick}>
    {children}
  </div>
);

export const MapCardHoverContainer = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={clsx(
      'absolute top-0 left-full ml-2 max-w-[24rem] overflow-hidden rounded-lg bg-slate1 p-4 [&>*:last-child]:mb-0',
      className
    )}
  >
    {children}
  </div>
);
